import { render, staticRenderFns } from "./TeamRecord.vue?vue&type=template&id=637fdacc&scoped=true&"
import script from "./TeamRecord.vue?vue&type=script&lang=js&"
export * from "./TeamRecord.vue?vue&type=script&lang=js&"
import style0 from "./TeamRecord.vue?vue&type=style&index=0&id=637fdacc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637fdacc",
  null
  
)

export default component.exports